import React, { Component } from "react";
import "./InfoPanel.css"
import PropTypes from "prop-types";

export default class InfoPanel extends Component {

    static propTypes = {
        rows: PropTypes.array.isRequired
    }

    render() {
        const { rows, compact, thin } = this.props;
        return (
            <div className="InfoPanel">
                {rows.filter( r => r !== undefined ).map( ( v, i ) => (
                    <div key={i} className={`InfoPanel-row${compact ? " InfoPanel-row-compact" : ""}`}>
                        <span className={thin ? "InfoPanel-column1-thin" : "InfoPanel-column1"}>
                            {v[0]}
                        </span>
                        <span className="InfoPanel-column2" style={{whiteSpace: 'pre-line'}}>
                            {v[1]}
                        </span>
                    </div>
                ) )}
            </div>
        );
    }

}